/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * CanvasRulerIcon
 */
export default class CanvasRulerIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M21 1a2 2 0 011.995 1.85L23 3v3a2 2 0 01-1.85 1.995L21 8 8 7.999V21a2 2 0 01-1.85 1.995L6 23H3a2 2 0 01-1.995-1.85L1 21V3a2 2 0 011.85-1.995L3 1h18zM6 7.999L3 8v13h3v-1h-.5a1 1 0 01-.117-1.993L5.5 18H6v-2H4.5a1 1 0 01-.117-1.993L4.5 14H6v-2h-.5a1 1 0 01-.117-1.993L5.5 10H6V7.999zM6 3H3v3l3-.001V3zm2 2.999L10 6v-.5a1 1 0 011.993-.117L12 5.5V6h2V4.5a1 1 0 011.993-.117L16 4.5V6h2v-.5a1 1 0 011.993-.117L20 5.5V6h1V3L8 2.999v3z" fillRule="evenodd"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

